import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const insightsPlugin = createPlugin({
  id: 'insights',
  routes: {
    root: rootRouteRef,
  },
});

export const InsightsPage = insightsPlugin.provide(
  createRoutableExtension({
    name: 'InsightsPage',
    component: () =>
      import('./components/InsightsPage').then(m => m.InsightsPage),
    mountPoint: rootRouteRef,
  }),
);
